import { usePolicyDetail } from "data/ss-data-hooks";

export const usePropertyUpdateRoof = () => {
  const { data, isLoading } = usePolicyDetail();
  const prevRoofYear = data?.userPropertyProfileData.constructionYearRoof;
  const prevRoofType = data?.userPropertyProfileData.roofCoveringType;

  return {
    loading: isLoading,
    prevRoofYear,
    prevRoofType,
  };
};
